import { render, staticRenderFns } from "./FeedbackSettings.vue?vue&type=template&id=19ad34e4"
import script from "./FeedbackSettings.vue?vue&type=script&lang=js"
export * from "./FeedbackSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports